module.exports = __webpack_public_path__ + "img/palm1_2.c1c1835e.png";